module.exports = __webpack_public_path__ + "media/img/home/directions/list-5-7c91c17df67704654156f1cebfd294ee.svg";